app.controller('teacherAppExerciseDoneCtrl', [
    '$scope', '$interval', 'gameService', '$state', '$stateParams', '$timeout', function ($scope, $interval, gameService, $state, $stateParams, $timeout) {
        var vm = this;

        vm.gameService = gameService;
        vm.exercise = gameService.exerciseWithIndex($stateParams.id);

        vm.progressIndex = 1 + vm.exercise.questions.length + 1 + vm.exercise.evaluationQuestions.length;
        vm.progressCount = 1 + vm.exercise.questions.length + 1 + vm.exercise.evaluationQuestions.length + 1;
        vm.progressArray = new Array(vm.progressCount);

        var parent = angular.element("#evalbeginarrow")[0];
        vm.arrow = new TivoliArrow(parent);
        vm.arrow.start();

        $scope.$on('$destroy', function() {
            vm.arrow.stop();
            vm.arrow = null;
        })

        vm.ebimageStyle = {
        	"background-image": "url(\"" + vm.exercise.imageUrl + "\")",
        	"background-size": "cover"
        };

        vm.next = function() {
            $state.go('teacherapp.exercises');
        }

        // -- CONFETTI --

        vm.confetti = new TG.Confetti({
            viewport: document.getElementsByClassName("confetticanvas")[0],
            texture: '/img/confetti-sprite.png',
            particleCount: 759,
            particleScale: 1.0
        });

        vm.fireConfettiLoop = function() {
            $timeout(function() {
                vm.confetti.fireCenterCannon();
            }, 750);
        }

        vm.initiateConfettiLoop = function() {
            vm.fireConfettiLoop();
        }

        vm.initiateConfettiLoop();

        $scope.$on('$destroy', function() {
            vm.confetti.dispose();
        });
   }
]);
